import { FlitServiceContext } from "../../../services/flitService";
import Moment from "react-moment";
import { useContext, useEffect, useState } from "react";
import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  LinearProgress,
  TablePagination,
  makeStyles,
} from "@material-ui/core";
import { AnnouncementDetailModal } from "./AnnouncementDetailModal";
import { useSelector } from "react-redux";
import { AnnouncementCreateModal } from "./AnnouncementCreateModal";
import { useIntl } from "react-intl";
import { getAnnouncementTypeCssClasses, getAnnouncementStatusCssClasses } from "./announcementHelper";
import cf from '../../../services/codeformatter'

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: "auto",
    padding: "8px",
  },
  ellipsisCell: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "300px", // Adjust as needed
  },
}));

/* -------------------------------------------------------------------------- */
/*                                    NOTES                                   */
/* -------------------------------------------------------------------------- */

// Columns need to add lastUpdatedOn, isActive

const headRows = [
  {
    id: "status",
    align: "left",
    disablepadding: false,
    label: "STATUS",
    width: "15%",
  },
  {
    id: "type",
    align: "left",
    disablepadding: false,
    label: "TYPE",
    width: "15%",
  },
  {
    id: "title",
    align: "left",
    disablePadding: false,
    label: "TITLE",
    width: "50%",
  },
  {
    id: "createdOn",
    align: "left",
    disablePadding: false,
    label: "CREATED_ON",
    //width: "20%",
  },
  {
    id: "lastUpdatedOn",
    align: "left",
    disablePadding: false,
    label: "UPDATED_ON",
    //width: "20%",
  },
];

export const SimpleAnnouncementList = ({}) => {
  const { flitSvc } = useContext(FlitServiceContext);
  const intl = useIntl();
  const { user } = useSelector(state => state.auth);
  const classes = useStyles(); //react material
  const [isAdminView, setIsAdminView] = useState(false);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdOn");
  const [announcementList, setAnnouncementList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

function handleRequestSort(property) { 
  const isDesc = orderBy === property && order === "desc";
  setOrder(isDesc ? "asc" : "desc");
  setOrderBy(property);
}

  function handleChangePage(event, newPage) {
    setCurrentPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setCurrentPage(0);
  }

  const fetchAnnouncements = async (top, skip, orderBy, order) => {
    setIsLoading(true);
    try {
      const res = await flitSvc.searchAnnouncements(top, skip, orderBy, order);

      setAnnouncementList(res.data?.value ?? []);
      setTotalCount(res.data["@odata.count"] ?? 0);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshAnnouncements = () => {
    fetchAnnouncements(rowsPerPage, currentPage * rowsPerPage, orderBy, order);
  };

  useEffect(() => {
    fetchAnnouncements(rowsPerPage, currentPage * rowsPerPage, orderBy, order);
  }, [currentPage, rowsPerPage, order, orderBy]);

  useEffect(() => {
    if (user) {
      const isAdmin = user.userRole.some(
        userRole => userRole.role === "DEVELOPER" || userRole.role === "MANAGER"
      );

      setIsAdminView(isAdmin);
    }
  }, [user]);

  return (
    <div className={classes.tableWrapper}>
      {isAdminView && (
        <AnnouncementCreateModal fetchAnnouncements={refreshAnnouncements} />
      )}
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        size="medium"
      >
        <TableHead>
          <TableRow>
            {headRows.map(row => {
              if (
                (row.id === "status" &&
                  user.userRole.some(
                    userRole =>
                      userRole.role === "DEVELOPER" ||
                      userRole.role === "MANAGER"
                  )) ||
                row.id !== "status"
              ) {
                return (
                  <TableCell
                    className="text-nowrap " // Removed unnecessary 'text-ellipsis overflow-hidden' if not needed
                    key={row.id}
                    align={row.align}
                    padding={row.disablePadding ? "none" : "default"}
                    sortDirection={orderBy === row.id ? order : false}
                    style={{ width: row.width }} // Added width from headRows
                  >
                    
                    <TableSortLabel
                      active={orderBy === row.id}
                      direction={order}
                      onClick={() => handleRequestSort(row.id)}
                    >
                      {intl.formatMessage({ id: row.label })} 
                    </TableSortLabel>
                  </TableCell>
                );
              }
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={headRows.length}
                style={{ textAlign: "center" }}
              >
                <LinearProgress />
              </TableCell>
            </TableRow>
          ) : (
            announcementList.map(row => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={row.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedRow(row);
                    setEditModalIsOpen(true);
                  }}
                >
                  {isAdminView && (
                    <TableCell >
                      <span className={getAnnouncementStatusCssClasses(row.status)}>
                          {cf.format('AnnouncementStatus', row.status, intl.locale)}
                      </span>
                    </TableCell>
                  )}
                  <TableCell>
                    <span className={getAnnouncementTypeCssClasses(row.type)}>
                          {cf.format('AnnouncementType', row.type, intl.locale)}
                      </span>
                  </TableCell>
                  <TableCell
                    //className={`align-top ${classes.ellipsisCell}`} // Apply ellipsis here
                    //style={{ width: "60%" }} // Example width (adjust to fit)
                  >
                    <span>{row.title}</span>
                  </TableCell>
                  <TableCell >
                    <Moment format="ll">{row.createdOn}</Moment>
                  </TableCell>
                  <TableCell>
                    <Moment format="ll">{row.lastUpdatedOn}</Moment>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 20]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        backIconButtonProps={{
          "aria-label": intl.formatMessage({ id: "PREVIOUS_PAGE" }),
        }}
        nextIconButtonProps={{
          "aria-label": intl.formatMessage({ id: "NEXT_PAGE" }),
        }}
      />
      {/* Single Modal Instance (rendered once, controlled by state) */}
      {selectedRow && (
        <AnnouncementDetailModal
          open={editModalIsOpen}
          setOpen={setEditModalIsOpen}
          onClose={() => setEditModalIsOpen(false)}
          row={selectedRow}
          fetchAnnouncements={refreshAnnouncements}
          isAdminView={isAdminView}
        />
      )}
    </div>
  );
};
